import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-rows: 0.2fr 2fr 2fr;

  padding: 0 5px 0 5px;
  background-color: white;
  min-width: 100%;
  height: 100%;

  :first-child {
    width: 30%;
  }

  @media (max-width: 520px) {
    padding: 0;
  }
`;

export const HeaderWrapper = styled.div`
  display: grid;
`;

export const GraphGrid = styled(Paper).attrs({
  elevation: 3,
})`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1rem;

  padding: 10px;
  height: 100%;

  @media (max-width: 520px) {
    padding: 0;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;
